import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useUserUpdateByAdminMutation = () => {
  return useMutation({
    mutationFn: api.user.updateUserManagementInfo,
  });
};

export default useUserUpdateByAdminMutation;
